/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Recommended By Scheduling List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './RecommendedBySchedulingListView';

export const mapStateToPropsRecommendedBySchedulingList = mapStateToProps;
export const mapDispatchToPropsRecommendedBySchedulingList = mapDispatchToProps;

export default connect(
  mapStateToPropsRecommendedBySchedulingList,
  mapDispatchToPropsRecommendedBySchedulingList
)(View);
